"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = exports.validationErrorMessages = exports.convertTemplateValues = exports.defaultHeightValue = exports.defaultMarginValue = void 0;
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const material_1 = require("@mui/material");
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const formik_mui_1 = require("formik-mui");
const yup = __importStar(require("yup"));
const lodash_1 = require("lodash");
const maybeStringToNum_1 = require("../../utils/maybeStringToNum/maybeStringToNum");
function getModalStyle() {
    const top = 50;
    const left = 50;
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        outline: "none",
    };
}
const StyledPaper = (0, material_1.styled)(Paper_1.default)(({ theme }) => ({
    position: "absolute",
    maxWidth: "1440px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "6px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
}));
const StyledTitle = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    textTransform: "uppercase",
    fontWeight: "bold",
}));
const StyledTemplateRow = (0, material_1.styled)("div")(({ theme }) => ({
    paddingBottom: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
}));
const StyledTemplateMiddleRowsWrapper = (0, material_1.styled)("div")({
    "&:last-child": {
        paddingBottom: 0,
    },
});
const StyledTemplateMiddleRows = (0, material_1.styled)("div")(({ theme }) => ({
    paddingBottom: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
    "& > *": {
        width: theme.spacing(33),
    },
}));
const StyledTemplateBottomRow = (0, material_1.styled)("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    "& > *": {
        width: theme.spacing(26),
    },
}));
const StyledSubmit = (0, material_1.styled)("div")(({ theme }) => ({
    margin: theme.spacing(8, -4, 0),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    "& > *": {
        float: "right",
        marginRight: theme.spacing(2),
    },
}));
const StyledFieldTemplateName = (0, material_1.styled)(formik_1.Field)(({ theme }) => ({
    width: theme.spacing(83),
}));
const StyledFormControlLanguage = (0, material_1.styled)(material_1.FormControl)(({ theme }) => ({
    width: theme.spacing(31),
}));
const StyledFieldDescription = (0, material_1.styled)(formik_1.Field)(({ theme }) => ({
    width: theme.spacing(119),
}));
const StyledButtonContainer = (0, material_1.styled)("div")({
    marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
});
exports.defaultMarginValue = 0;
exports.defaultHeightValue = 0.1;
const convertTemplateValues = (values, entityType, pageNumberFont) => ({
    ...values,
    pageNumberEnabled: values.pageNumberEnabled ?? false,
    pageNumberFont: values.pageNumberFont ?? pageNumberFont,
    topMargin: (0, maybeStringToNum_1.maybeStringToNum)(values.topMargin, exports.defaultMarginValue),
    leftMargin: (0, maybeStringToNum_1.maybeStringToNum)(values.leftMargin, exports.defaultMarginValue),
    rightMargin: (0, maybeStringToNum_1.maybeStringToNum)(values.rightMargin, exports.defaultMarginValue),
    bottomMargin: (0, maybeStringToNum_1.maybeStringToNum)(values.bottomMargin, exports.defaultMarginValue),
    headerEnabled: values.headerEnabled ?? false,
    footerEnabled: values.footerEnabled ?? false,
    headerHeight: (0, maybeStringToNum_1.maybeStringToNum)(values.headerHeight, exports.defaultHeightValue),
    footerHeight: (0, maybeStringToNum_1.maybeStringToNum)(values.footerHeight, exports.defaultHeightValue),
    entityType,
});
exports.convertTemplateValues = convertTemplateValues;
var validationErrorMessages;
(function (validationErrorMessages) {
    /* eslint-disable no-template-curly-in-string */
    validationErrorMessages["headerHeightLimit"] = "Header height in addition to top margin exceeds 2.5 inches";
    validationErrorMessages["headerHeightTypeError"] = "Header height must be a ${type}";
    validationErrorMessages["footerHeightTypeError"] = "Footer margin must be a ${type}";
    validationErrorMessages["topMarginTypeError"] = "Top margin must be a ${type}";
    validationErrorMessages["bottomMarginTypeError"] = "Bottom margin must be a ${type}";
    validationErrorMessages["leftMarginTypeError"] = "Left margin must be a ${type}";
    validationErrorMessages["rightMarginTypeError"] = "Right margin must be a ${type}";
    /* eslint-enable no-template-curly-in-string */
})(validationErrorMessages = exports.validationErrorMessages || (exports.validationErrorMessages = {}));
exports.validationSchema = yup.object().shape({
    entityType: yup.string().oneOf(["provider", "member"]),
    name: yup.string().required().label("Template name"),
    description: yup.string().required().label("Document description"),
    language: yup.string().oneOf(["en", "es"]).label("Language"),
    headerEnabled: yup.boolean().label("Header enabled"),
    footerEnabled: yup.boolean().label("Footer enabled"),
    headerHeight: yup
        .number()
        .positive()
        .when(["headerEnabled", "topMargin"], ([headerEnabledForWhenCallback, topMarginForWhenCallback], schema) => {
        if (headerEnabledForWhenCallback) {
            schema.required();
            return schema.test({
                test: (headerHeightInput) => headerHeightInput + topMarginForWhenCallback <= 2.5,
                message: validationErrorMessages.headerHeightLimit,
            });
        }
        schema.notRequired();
        return schema;
    })
        .label("Header height")
        .typeError(validationErrorMessages.headerHeightTypeError),
    footerHeight: yup
        .number()
        .positive()
        .when("footerEnabled", {
        is: true,
        then: () => yup.number().required(),
        otherwise: () => yup.number().notRequired(),
    })
        .label("Footer height")
        .typeError(validationErrorMessages.footerHeightTypeError),
    pageNumberEnabled: yup.boolean().label("Page numbers"),
    pageNumberFont: yup
        .string()
        .oneOf(["Arial", "Courier New", "Times New Roman", "Roboto"])
        .label("Page numbers font"),
    topMargin: yup
        .number()
        .positive()
        .required()
        .label("Top margin")
        .typeError(validationErrorMessages.topMarginTypeError),
    bottomMargin: yup
        .number()
        .positive()
        .required()
        .label("Bottom margin")
        .typeError(validationErrorMessages.bottomMarginTypeError),
    leftMargin: yup
        .number()
        .positive()
        .required()
        .label("Left margin")
        .typeError(validationErrorMessages.leftMarginTypeError),
    rightMargin: yup
        .number()
        .positive()
        .required()
        .label("Right margin")
        .typeError(validationErrorMessages.rightMarginTypeError),
});
exports.default = ({ templateFormConfig, selectedTemplate, isSaving, isSaveSuccess, error, onSuccess, onSubmit, }) => {
    const { edit = false, title = "Blank Template", open, setOpen, name = "", language = "en", description, headerEnabled = true, footerEnabled = true, headerHeight = 1.5, footerHeight = 1.5, topMargin = 1, bottomMargin = 1, leftMargin = 0.5, rightMargin = 0.5, pageNumberEnabled = true, pageNumberFont = "Roboto", entityType, duplicateTemplate, headerEditorOpen = false, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setHeaderEditorOpen = () => { }, bodyHtml, } = templateFormConfig;
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle, setModalStyle] = (0, react_1.useState)(getModalStyle);
    const defaultTemplate = {
        headerEnabled,
        footerEnabled,
        headerHeight,
        footerHeight,
        topMargin,
        bottomMargin,
        leftMargin,
        rightMargin,
        pageNumberEnabled,
        pageNumberFont,
    };
    const initialState = edit && selectedTemplate
        ? selectedTemplate
        : duplicateTemplate || {
            name,
            language,
            description,
            entityType,
            bodyHtml,
            ...defaultTemplate,
        };
    const [state, setState] = (0, react_1.useState)(initialState);
    const [formikBag, setFormikBag] = (0, react_1.useState)(null);
    const [confirmationOpen, setConfirmationOpen] = (0, react_1.useState)(false);
    const openConfirmation = () => {
        setConfirmationOpen(true);
    };
    const closeConfirmation = () => {
        setConfirmationOpen(false);
    };
    const handleClose = (0, react_1.useCallback)(() => {
        setOpen(false);
    }, [setOpen]);
    // @TODO: refactor this to reduce complexity
    // eslint-disable-next-line complexity
    (0, react_1.useEffect)(() => {
        // Either we changed form types or the submission was successful so the
        // state should be reset to its initial values.
        if (!isSaving && isSaveSuccess !== false && !selectedTemplate) {
            setState(initialState);
        }
        else if (selectedTemplate && !(0, lodash_1.isEqual)(state, selectedTemplate)) {
            setState(selectedTemplate);
        }
        if (isSaving === false && isSaveSuccess) {
            // Form submission success.
            if (!edit && selectedTemplate) {
                onSuccess();
            }
            else {
                handleClose();
            }
            if (formikBag) {
                formikBag.setSubmitting(false);
                setFormikBag(null);
            }
        }
        else if (formikBag && isSaving === false && isSaveSuccess === false) {
            // Form submission failure.
            formikBag.setSubmitting(false);
            if (error) {
                const errMsg = (0, lodash_1.get)(error, "response.data.message", error.message);
                if (errMsg ===
                    "please specify another name. there is already a record with the given name.") {
                    formikBag.setErrors({ name: errMsg });
                }
                // @TODO - display other server-side errors
            }
        }
    }, [
        edit,
        entityType,
        isSaving,
        isSaveSuccess,
        setState,
        handleClose,
        selectedTemplate,
        state,
        formikBag,
    ]);
    return (react_1.default.createElement(material_1.Modal, { open: open, onClose: handleClose, "aria-labelledby": "edit-template-modal-title" },
        react_1.default.createElement(StyledPaper, { style: modalStyle },
            react_1.default.createElement(StyledTitle, { variant: "subtitle1" }, title),
            react_1.default.createElement(formik_1.Formik, { initialValues: state, 
                /* eslint-disable no-template-curly-in-string */
                validationSchema: exports.validationSchema, 
                /* eslint-enable */
                onSubmit: (values, FormikBag) => {
                    setState(values);
                    const template = (0, exports.convertTemplateValues)(values, entityType, pageNumberFont);
                    setFormikBag(FormikBag);
                    onSubmit(template);
                    FormikBag.setSubmitting(true);
                    setConfirmationOpen(false);
                    setHeaderEditorOpen(false);
                } }, ({ values, handleChange, handleBlur, handleSubmit }) => (react_1.default.createElement(formik_1.Form, { onSubmit: handleSubmit },
                react_1.default.createElement(StyledTemplateRow, null,
                    react_1.default.createElement(StyledFieldTemplateName, { component: formik_mui_1.TextField, id: "name", name: "name", label: "Template name", variant: "filled", value: values.name, onChange: handleChange, onBlur: handleBlur }),
                    react_1.default.createElement(StyledFormControlLanguage, { variant: "filled" },
                        react_1.default.createElement(material_1.InputLabel, { id: "language-label" }, "Language"),
                        react_1.default.createElement(formik_1.Field, { component: formik_mui_1.Select, labelId: "language-label", id: "language", name: "language", value: values.language, onChange: handleChange, onBlur: handleBlur },
                            react_1.default.createElement(material_1.MenuItem, { value: "en" }, "English"),
                            react_1.default.createElement(material_1.MenuItem, { value: "es" }, "Spanish")))),
                react_1.default.createElement(StyledTemplateRow, null,
                    react_1.default.createElement(StyledFieldDescription, { component: formik_mui_1.TextField, id: "description", name: "description", label: "Document description", variant: "filled", value: values.description, onChange: handleChange, onBlur: handleBlur })),
                react_1.default.createElement(StyledTemplateMiddleRowsWrapper, null,
                    react_1.default.createElement(material_1.Typography, { variant: "overline" }, "Header and footer"),
                    react_1.default.createElement(StyledTemplateMiddleRows, null,
                        react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(formik_1.Field, { component: formik_mui_1.Switch, checked: values.headerEnabled, onChange: handleChange, onBlur: handleBlur, name: "headerEnabled", type: "checkbox" }), label: "Include header" }),
                        react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(formik_1.Field, { component: formik_mui_1.Switch, checked: values.footerEnabled, onChange: handleChange, onBlur: handleBlur, name: "footerEnabled", type: "checkbox" }), label: "Include footer" }),
                        react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(formik_1.Field, { component: formik_mui_1.Switch, checked: values.pageNumberEnabled, onChange: handleChange, onBlur: handleBlur, name: "pageNumberEnabled", type: "checkbox" }), label: "Include page #'s" }))),
                react_1.default.createElement(StyledTemplateMiddleRows, null,
                    react_1.default.createElement(formik_1.Field, { component: formik_mui_1.TextField, id: "headerHeight", name: "headerHeight", label: "Header height (in inches)", variant: "filled", value: values.headerHeight, onChange: handleChange, onBlur: handleBlur, disabled: !values.headerEnabled }),
                    react_1.default.createElement(formik_1.Field, { component: formik_mui_1.TextField, id: "footerHeight", name: "footerHeight", label: "Footer height (in inches)", variant: "filled", value: values.footerHeight, onChange: handleChange, onBlur: handleBlur, disabled: !values.footerEnabled }),
                    react_1.default.createElement(material_1.FormControl, { variant: "filled" },
                        react_1.default.createElement(material_1.InputLabel, { id: "pageNumberFont-label" }, "Page number font"),
                        react_1.default.createElement(formik_1.Field, { component: formik_mui_1.Select, labelId: "pageNumberFont-label", id: "pageNumberFont", name: "pageNumberFont", value: values.pageNumberFont, onChange: handleChange, onBlur: handleBlur, disabled: !values.pageNumberEnabled },
                            react_1.default.createElement(material_1.MenuItem, { value: "Arial" }, "Arial"),
                            react_1.default.createElement(material_1.MenuItem, { value: "Courier New" }, "Courier New"),
                            react_1.default.createElement(material_1.MenuItem, { value: "Times New Roman" }, "Times New Roman"),
                            react_1.default.createElement(material_1.MenuItem, { value: "Roboto" }, "Roboto")))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(material_1.Typography, { variant: "overline" }, "Margins"),
                    react_1.default.createElement(StyledTemplateBottomRow, null,
                        react_1.default.createElement(formik_1.Field, { component: formik_mui_1.TextField, id: "topMargin", name: "topMargin", label: "Top margin (in inches)", variant: "filled", value: values.topMargin, onChange: handleChange, onBlur: handleBlur }),
                        react_1.default.createElement(formik_1.Field, { component: formik_mui_1.TextField, id: "bottomMargin", name: "bottomMargin", label: "Bottom margin (in inches)", variant: "filled", value: values.bottomMargin, onChange: handleChange, onBlur: handleBlur }),
                        react_1.default.createElement(formik_1.Field, { component: formik_mui_1.TextField, id: "leftMargin", name: "leftMargin", label: "Left margin (in inches)", variant: "filled", value: values.leftMargin, onChange: handleChange, onBlur: handleBlur }),
                        react_1.default.createElement(formik_1.Field, { component: formik_mui_1.TextField, id: "rightMargin", name: "rightMargin", label: "Right margin (in inches)", variant: "filled", value: values.rightMargin, onChange: handleChange, onBlur: handleBlur }))),
                react_1.default.createElement(StyledSubmit, null,
                    react_1.default.createElement(material_1.Button, { onClick: () => {
                            if (values.headerHeight !== state.headerHeight &&
                                headerEditorOpen) {
                                openConfirmation();
                            }
                            else {
                                handleSubmit();
                            }
                        } }, "Ok"),
                    react_1.default.createElement(material_1.Modal, { open: confirmationOpen, onClose: closeConfirmation, "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description" },
                        react_1.default.createElement(StyledPaper, { style: modalStyle },
                            react_1.default.createElement("h2", { id: "simple-modal-title" }, "Are you sure?"),
                            react_1.default.createElement("div", { id: "simple-modal-description" },
                                react_1.default.createElement("div", null, "Your header changes have not been saved."),
                                " ",
                                react_1.default.createElement("div", null, "Changing header height will result in changes lost.")),
                            react_1.default.createElement(StyledButtonContainer, null,
                                react_1.default.createElement(material_1.Button, { onClick: () => {
                                        handleSubmit();
                                    } }, "Yes"),
                                react_1.default.createElement(material_1.Button, { onClick: closeConfirmation }, "No")))),
                    react_1.default.createElement(material_1.Button, { onClick: handleClose }, "Cancel"))))))));
};
